var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export const copyTextToClipboard = (msg) => __awaiter(void 0, void 0, void 0, function* () {
    const el = document.createElement('div');
    el.innerHTML = msg.text;
    const textWithoutTags = el.textContent || '';
    try {
        yield navigator.clipboard.writeText(textWithoutTags);
        console.log('Text copied to clipboard');
        return true;
    }
    catch (err) {
        console.error('Failed to copy text: ', err);
    }
});
